import React, { useState } from "react"
import { ResourceStats } from "../components/ui/learning-resources/resource-stats"
import { ResourceCard } from "../components/ui/learning-resources/resource-card"
import { ResourceTabs } from "../components/ui/learning-resources/resource-tabs"
import { Sidebar } from "../components/ui/sidebar"
import { UniversalSearch } from "../components/ui/universal-search"
import {AIChatBox} from "../components/ui/ai-chat-box";
import ProtectedRoute from "../components/ProtectedRoute"

export default function LearningResourcesPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen)
  const closeSidebar = () => setIsSidebarOpen(false)

  const resources = [
    {
      title: "Introduction to Algebra",
      description: "Fundamentals of algebraic expressions and equations.",
      subject: "Mathematics",
      assignedDate: "24 Sep, 2023",
      files: [
        { name: "Chapter 1.pdf", size: "1.2 MB", type: "pdf" },
        { name: "Worksheet.docx", size: "450 KB", type: "docx" },
      ],
      status: "completed",
      collaborators: ["/diverse-group-avatars.png", "/pandoran-bioluminescent-forest.png"],
    },
    {
      title: "Photosynthesis Explained",
      description: "An in-depth video lecture on how plants create energy.",
      subject: "Biology",
      assignedDate: "15 Oct, 2023",
      files: [
        { name: "Lecture Video.mp4", size: "128 MB", type: "video" },
        { name: "Summary Notes.pdf", size: "800 KB", type: "pdf" },
      ],
      status: "in-progress",
      progress: 45,
    },
    {
      title: "World War II History",
      description: "Reading materials on the major events of WWII.",
      subject: "History",
      assignedDate: "20 Oct, 2023",
      files: [{ name: "Causes of WWII.pdf", size: "2.5 MB", type: "pdf" }],
      status: "not-started",
    },
  ]

  const handleSearch = (query) => {
    console.log("Universal search for:", query)
  }

  return (
    <ProtectedRoute>
       <div className="flex min-h-screen bg-slate-200">
      {/* Sidebar (Self-contained, handles own toggle) */}
      <Sidebar/>

      <AIChatBox />

      {/* Universal Search Component */}
      <UniversalSearch onSearch={handleSearch} />

      {/* Main content */}
      <div className="flex-1 flex flex-col w-full transition-all duration-300 ease-in-out lg:ml-64">
        {/* Mobile Header */}
        <div className="md:hidden flex items-center gap-3 p-4 border-b border-slate-200 bg-white">
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6 text-slate-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div className="flex-1">
            <h1 className="text-xl font-bold text-slate-900">Learning Resources</h1>
            <p className="text-sm text-slate-600">Your educational materials</p>
          </div>
        </div>

        {/* Mobile Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/10 backdrop-blur-sm md:hidden transition-all duration-300"
            onClick={closeSidebar}
          />
        )}

        <main className={`flex-1 p-4 sm:p-6 md:p-8 overflow-y-auto transition-all duration-300 ${
          isSidebarOpen ? "blur-sm pointer-events-none md:blur-0 md:pointer-events-auto" : ""
        }`}>
          <div className="max-w-6xl mx-auto">
            {/* Desktop Header */}
            <h2 className="hidden md:block text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-black">
              My Learning Resources
            </h2>

            {/* Stats */}
            <div className="mb-6 sm:mb-8 overflow-x-auto">
              <ResourceStats />
            </div>

            {/* Tabs and Resources */}
            <ResourceTabs>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {resources.map((resource, idx) => (
                  <ResourceCard key={idx} {...resource} />
                ))}
              </div>
            </ResourceTabs>
          </div>
        </main>
      </div>
    </div>
    </ProtectedRoute>
  )
}